<grid-virtual-scroll-viewport class="main-grid" (onScroll)="archiveListDataSource.onScroll($event)">
	<div *gridVirtualFor="let rows of archiveListDataSource; itemMinWidth: minWidth; itemMaxWidth: maxWidth; minGap: minGap;">
		<div *ngFor="let item of rows;" class="columns">
			<ngx-archive-card [archive]="item"></ngx-archive-card>
		</div>
	</div>
</grid-virtual-scroll-viewport>
